import React, { useRef, useState, useEffect } from "react";
import { useFormik } from "formik";
import * as apicall from "../../components/Apicall";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { Form } from "react-bootstrap";
import Loader from "../../components/Loader/Loader";
import FieldHelpTooltip from "../../components/Help/FieldHelpTooltip";
import { HELP_CONTENT } from "../../components/Help/HelpContent";

const AddService = ({ onHideService , setNewService}) => {
  // Fetched fresh rather than trusted from localStorage.userDetails, which is
  // written by several independent fetches elsewhere and can be stale.
  const [industry, setIndustry] = useState(null);
  useEffect(() => {
    apicall.get("ezpMyProfile").then((res) => {
      setIndustry(res?.data?.[0]?.industry);
    }).catch(() => {});
  }, []);
  const isClinicService = Number(industry) === 1;
  const isSportsService = Number(industry) === 7;
  const [isType, setIsType] = useState(false);
    const [allService, setAllService] = useState([]);
  const { offerings_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { serviceName, offering, mode, service_id } = location.state || {};
  const [iconPreview, setIconPreview] = useState(null);

  const [loading, setLoading] = useState(false);

  const fileInputIconRef = useRef(null);

  const ICON_SIZE_LIMIT = 100 * 1024;
  const IMAGE_SIZE_LIMIT = 500 * 1024;
  const ICON_DIMENSIONS_WIDTH = 260;
  const ICON_DIMENSIONS_HEIGHT = 260;
  const IMAGE_DIMENSIONS_WIDTH = 720;
  const IMAGE_DIMENSIONS_HEIGHT = 720;

const normalize = (val) => {
  return String(val || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .trim();
};
  const validationSchema = Yup.object({
     name: Yup.string()
    .max(40, "Max 40 characters allowed")
    .required("Name is required")
    .test(
      "duplicate-check",
      "Service already exists",
      function (value) {
        if (!value) return true;

        const normalizedValue = normalize(value);

        const isDuplicate = allService?.some(
          (item) => normalize(item) === normalizedValue
        );

        return !isDuplicate;
      }
    ),

    description: Yup.string().max(1900, "Max 1900 characters allowed"),
  });
  const getAllService = async (data) => {
    try {
        const response = await apicall.get(`getAllService`);
        setAllService(response?.data?.map((ele) => ele?.name));
      
    } catch (e) {
      console.log("err---", e);
    }
  };
useEffect(() => {
  getAllService();
}, []);
  const formik = useFormik({
    initialValues: {
      name: offering?.name || "",
      description: offering?.description != "null" ? offering?.description : "",
      icon: iconPreview,
    },
    validationSchema,
    onSubmit: async (values) => {
      // if (!iconPreview) {
      //   toast.error("Please upload an icon");
      //   return;
      // }

      setLoading(true);

      try {
        const data = {
          name: values.name?.charAt(0).toUpperCase() + values.name?.slice(1),
          description: values.description,
          icon: iconPreview,
          service_type: isType ? 1 : 0,
        };
        // console.log("data----", data);

        var res = await apicall.post(data, "add_service");
        if (res.success) {
          toast.success(res.message);
          if (setNewService) {
        setNewService(res.data); // assuming API returns created service
      }
      onHideService(res.data);
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error(error.message.replace("Error:", ""));
      } finally {
        setLoading(false);
      }
    },
  });

  const getInputClass = (field) => {
    return formik.touched[field] && formik.errors[field]
      ? "form-control is-invalid"
      : "form-control";
  };

  const getPlaceholder = (field) => {
    return formik.errors[field] || "";
  };

  const handleIconUpload = () => {
    fileInputIconRef.current?.click();
  };

  const convertToBase64 = (file, type) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (type === "icon") {
        setIconPreview(reader.result);
      }
    };
  };

  const handleIconChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > ICON_SIZE_LIMIT) {
        toast.error("Icon file size is too large");
        return;
      }
      let newImage = new Image();
      newImage.src = URL.createObjectURL(file);
      newImage.onload = () => {
        let w = newImage.width;
        let h = newImage.height;
        if (w <= ICON_DIMENSIONS_WIDTH && h <= ICON_DIMENSIONS_HEIGHT) {
          convertToBase64(file, "icon");
        } else {
          toast.error("Icon file is too large");
        }
      };
    }
  };

  const handleCancel = (data) => {
    onHideService();
    // navigate(`/service_offerings/${service_id}`, {
    //   state: { service_name: serviceName },
    // });
  };

  const urlToBase64 = async (url, type) => {
    if (type === "icon") {
      setIconPreview(url);
    }
  };

  useEffect(() => {
    if (offering?.icon) {
      urlToBase64(offering.icon, "icon");
    }
    if (offering?.description_image) {
      urlToBase64(offering.description_image, "image");
    }
  }, []);

  return (
    <div className="container bg-white">
      <form onSubmit={formik.handleSubmit}>
        <div className="row mb-3 ">
          <div className={isClinicService ? "col-md-12" : "col-md-6"}>
            <label htmlFor="name" className="label">
              {isClinicService ? "Specialization" : isSportsService ? "Sport" : "Service Category"}{" "}
              <FieldHelpTooltip {...HELP_CONTENT.addService.serviceName} />
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className={getInputClass("name")}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength="40"
              placeholder={getPlaceholder("name")}
            />
            <div className="invalid-feedback">{formik.errors.name}</div>
          </div>
          {!isClinicService && (
            <div className="col-md-6">
              <label htmlFor="name" className="label">
                Sub Category <FieldHelpTooltip {...HELP_CONTENT.addService.isSubCategory} />
              </label>
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isType} // value of the switch
                onChange={(e) => setIsType(e.target.checked)} // update value
                //   label="Check this switch"
              />
            </div>
          )}
        </div>

        <div className="mb-3 mt-4">
          <label htmlFor="description" className="label">
            Description <FieldHelpTooltip {...HELP_CONTENT.addService.description} />
          </label>
          <textarea
            id="description"
            name="description"
            className={getInputClass("description")}
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder={getPlaceholder("description")}
            rows={5}
            maxLength="1900"
          />
          <div className="invalid-feedback">{formik.errors.description}</div>
        </div>

        <div className="form-group ">
          <div className="d-flex align-items-center">
            <div className="me-4">
              {iconPreview ? (
                <div className="d-flex align-items-center">
                  <img
                    src={iconPreview}
                    alt="Uploaded Icon"
                    className="img-fluid me-3 uploaded-image"
                    height={60}
                    width={60}
                  />
                  <button
                    type="button"
                    className="btn primaryColorText btn-outline-secondary ms-2"
                    onClick={() => {
                      setIconPreview(null);
                      if (fileInputIconRef.current) {
                        fileInputIconRef.current.value = "";
                      }
                    }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <>
                  <label className="content mb-2">Upload an Icon:</label>
                  <button
                    type="button"
                    className="btn primaryColorText btn-outline-secondary ms-3 mb-2 mt-2"
                    onClick={handleIconUpload}
                  >
                    Upload
                  </button>
                  <input
                    type="file"
                    id="upload-icon"
                    ref={fileInputIconRef}
                    className="d-none"
                    onChange={handleIconChange}
                  />
                </>
              )}
              <div className="img-info">
                Max Size: {ICON_SIZE_LIMIT / 1024} KB
                <br />
                Dimensions: {ICON_DIMENSIONS_WIDTH}w x {ICON_DIMENSIONS_HEIGHT}{" "}
                h
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-2 mb-4">
          <button
            type="button"
            className="btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect mt-4"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center mt-4"
          >
            {loading ? <Loader style={{ width: 40, height: 20 }} /> : "Next"}
          </button>
        </div>
      </form>

      <ToastContainer />
    </div>
  );
};

export default AddService;
